import { generatePath, useLocation } from 'react-router-dom';

import { catchAll } from '@sorare/routing';

import { Rarity } from '__generated__/globalTypes';
import {
  ANY_SPORT_MARKET,
  ANY_SPORT_MY_CARDS,
  ANY_SPORT_MY_CARDS_ESSENCE,
  ANY_SPORT_MY_CARDS_REVEALABLE_CARDS,
  ANY_SPORT_PLAY,
  ANY_SPORT_SCOUTING_CENTER,
  FOOTBALL_MARKET_COMMON_PACKS,
  FOOTBALL_MY_CARDS_CARDS_TYPE,
} from 'constants/__generated__/routes';
import { matchAnySportPath } from 'lib/routing/generateSportPath';

import { InGameCurrencyAgreggated } from '../AppNavigation/UserCurrencies/useUserCurrencies';

export const useExpandedCurrencies = () => {
  const { pathname } = useLocation();

  if (!pathname) {
    return [];
  }

  const isPlay = !!matchAnySportPath(catchAll(ANY_SPORT_PLAY), pathname);
  const isScoutingCenter = !!matchAnySportPath(
    catchAll(ANY_SPORT_SCOUTING_CENTER),
    pathname
  );
  const isMarket = !!matchAnySportPath(catchAll(ANY_SPORT_MARKET), pathname);
  const isMyCards = !!matchAnySportPath(catchAll(ANY_SPORT_MY_CARDS), pathname);

  const isCommonMarket = !!matchAnySportPath(
    catchAll(FOOTBALL_MARKET_COMMON_PACKS),
    pathname
  );
  const isCommonMyCards = !!matchAnySportPath(
    catchAll(
      generatePath(FOOTBALL_MY_CARDS_CARDS_TYPE, { type: Rarity.common })
    ),
    pathname
  );

  /* From more specific condition to more generalist one */

  if (isCommonMyCards) {
    return [InGameCurrencyAgreggated.XP, InGameCurrencyAgreggated.SHARDS];
  }
  if (isCommonMarket) {
    return [InGameCurrencyAgreggated.GEMS, InGameCurrencyAgreggated.SHARDS];
  }
  if (matchAnySportPath(catchAll(ANY_SPORT_MY_CARDS_ESSENCE), pathname)) {
    return [InGameCurrencyAgreggated.SHARDS];
  }
  if (
    matchAnySportPath(catchAll(ANY_SPORT_MY_CARDS_REVEALABLE_CARDS), pathname)
  ) {
    return [InGameCurrencyAgreggated.BLUEPRINTS];
  }
  if (isMyCards) {
    return [InGameCurrencyAgreggated.XP, InGameCurrencyAgreggated.ENERGY];
  }
  if (isPlay || isScoutingCenter || isMarket) {
    return [InGameCurrencyAgreggated.SHARDS];
  }

  /* Other routes */
  return [];
};
